import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import {
  fetchAllEntries, clearAllEntries, setAllEntriesGrouping, getAllEntries
} from 'presentations/ducks';
import { getProject } from 'project/ducks/project';
import { getProjectIdFromUrl } from 'project/utils';
import { ENTRIES_RESOURCE_NAME } from 'presentations/constants';
import Entries from 'focus_groups/components/entries';

const mapStateToProps = (state) => {
  const { grouped, isFetching } = state.project.presentations.allEntries;
  const project = getProject(state);

  return {
    itemVariation: 'presentationEntries',
    resourceName: ENTRIES_RESOURCE_NAME,
    entries: getAllEntries(state),
    project,
    grouped,
    isFetching,
  };
}

const mapDispatchToProps = (dispatch, { params, location }) => {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    fetch: partial(fetchAllEntries, projectId, location.query),
    clear: clearAllEntries,
    setGrouping: setAllEntriesGrouping
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Entries));



// WEBPACK FOOTER //
// ./presentations/containers/entries.js